module.exports = __webpack_public_path__ + "static/media/mitsl200-2wd.f0dc00b5.jpg";